import React from 'react'
import AuthorizeComponent from '../Components/Authorize/AuthorizeComponent'

function AuthorizePage() {
    return (
        <AuthorizeComponent/>
    )
}

export default AuthorizePage